<template>
  <div class="tag-wrapper" v-click-outside="closeForm">
    <div class="tag">
      <span class="tag-head" @click="toggleForm">
        {{title}}: <span class="tagsList">{{selectedItemsName}}</span>
      </span>
      <span class="tag-close" @click="removeTag">
        <i class="close"></i>
      </span>
      <div class="tag-data" v-if="showTagData">
        <Multiselect 
            :options="options"
            :selectedOptions="selectedOptions"
            :title="title"
            :open="true"
            :removeIcon="true"
            @apply="onApply"
            @cancel="onCancel"
        />
      </div>
    </div>
  </div>
</template>

<script>

  import Multiselect from '@/components/common/multiselect/v1/MultiSelect.vue';

  export default {
    name: "tag-multi-select",
    components: {
      Multiselect
    },
    props: {
      options: {
        type: Array,
        required: true
      },
      selectedOptions: {
        type: Array,
        required: true
      },      
      title: {
        type: String,
        required: true
      } 
    },
    data(){
      return {
        showTagData: false        
      }
    },
    computed: { 
      selectedItemsName: function() {
        let self = this;
        let selected = this.options.filter( option => {
          return self.selectedOptions.indexOf(option.value) !== -1
        })

        let names = selected.map(item => item.title);
        let moreLength = names.length - 2;

        names = names.slice(0,2);
        if( moreLength > 0 ) {
          names.push(moreLength + ' more');
        }

        return names.join(', ');
      }      
    },
    methods: {
      toggleForm: function(){
        this.showTagData = !this.showTagData;
      },
      closeForm: function(){
        this.showTagData = false;
      },
      removeTag: function(){
        this.showTagData = false;
        this.onApply([]);
      },
      closeTagForm: function(){
        this.showTagData = false;
      },
      onApply(selected) {
        this.closeTagForm();
        this.$emit('apply', selected);
      },
      onCancel() {
        this.closeTagForm();
      }
    }
  }
</script>

<style lang="scss">

  .tag-data {
     .sitesListFilter {
      color: #797979;
      span {
        font-weight: bold;
      }
     }
  }

  .ui-collapsible__header{
    cursor:auto;
    background: #fff !important;
  }
</style>


<style lang="scss" scoped>
    @import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/common/tagMultiselect/v1/TagMultiselect.vue